import React from 'react';
import { TREND_BUCKETS } from './etfUtils';

// 의존성 없는 순수 SVG 라인 차트.
// series: [{ name, color, values: [number|null × 5] }]
//   - 값은 TREND_BUCKETS(과거→현재)와 1:1 정렬
//   - normalize=true 면 각 시리즈를 첫 유효값 기준 100으로 지수화(비교용)
export default function TrendChart({ series = [], normalize = false, height = 240, formatY }) {
  const W = 600;
  const H = height;
  const PAD = { top: 16, right: 16, bottom: 28, left: 48 };
  const innerW = W - PAD.left - PAD.right;
  const innerH = H - PAD.top - PAD.bottom;
  const n = TREND_BUCKETS.length;

  // 표시용으로 가공한 시리즈(지수화 옵션 반영)
  const plotted = series.map((s) => {
    let values = s.values;
    if (normalize) {
      const first = values.find((v) => v !== null && v !== undefined);
      values = first ? values.map((v) => (v === null || v === undefined ? null : (v / first) * 100)) : values;
    }
    return { ...s, values };
  });

  // 전체 y 범위
  const all = plotted.flatMap((s) => s.values).filter((v) => v !== null && v !== undefined);
  if (all.length === 0) {
    return <p className="text-center text-white/40 py-10 text-sm">추이를 그릴 데이터가 부족합니다.</p>;
  }
  let min = Math.min(...all);
  let max = Math.max(...all);
  if (min === max) { min -= 1; max += 1; }
  const span = max - min;
  const pad = span * 0.12;
  min -= pad; max += pad;

  const x = (i) => PAD.left + (n === 1 ? innerW / 2 : (i / (n - 1)) * innerW);
  const y = (v) => PAD.top + innerH - ((v - min) / (max - min)) * innerH;

  // y축 눈금 4단계
  const ticks = Array.from({ length: 5 }, (_, k) => min + (k / 4) * (max - min));
  const fmt = formatY || ((v) => (normalize ? v.toFixed(0) : Math.round(v).toLocaleString('ko-KR')));

  // 연속 구간만 path 로 연결 (null 은 끊음)
  const buildPath = (values) => {
    let d = '';
    let pen = false;
    values.forEach((v, i) => {
      if (v === null || v === undefined) { pen = false; return; }
      d += `${pen ? 'L' : 'M'}${x(i).toFixed(1)},${y(v).toFixed(1)} `;
      pen = true;
    });
    return d.trim();
  };

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" style={{ display: 'block' }}>
      {/* 가로 그리드 + y축 라벨 */}
      {ticks.map((t, i) => (
        <g key={i}>
          <line x1={PAD.left} y1={y(t)} x2={W - PAD.right} y2={y(t)}
            stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
          <text x={PAD.left - 8} y={y(t) + 3} textAnchor="end"
            fill="rgba(255,255,255,0.4)" fontSize="10">{fmt(t)}</text>
        </g>
      ))}

      {/* x축 라벨 */}
      {TREND_BUCKETS.map((b, i) => (
        <text key={b} x={x(i)} y={H - 8} textAnchor="middle"
          fill="rgba(255,255,255,0.4)" fontSize="10">{b}</text>
      ))}

      {/* 시리즈 */}
      {plotted.map((s, si) => (
        <g key={si}>
          <path d={buildPath(s.values)} fill="none" stroke={s.color} strokeWidth="2.5"
            strokeLinejoin="round" strokeLinecap="round" />
          {s.values.map((v, i) =>
            v === null || v === undefined ? null : (
              <circle key={i} cx={x(i)} cy={y(v)} r="3.5" fill="#060c1a" stroke={s.color} strokeWidth="2" />
            )
          )}
        </g>
      ))}
    </svg>
  );
}
